import React, { useState, useRef, useEffect, useCallback } from 'react';
import { getListedNftList, getOwnedNftList, getOwnOnSaleItem, getOwnProfile, getProfileByUsername, getUserCreatedNftList, uploadProfileCover } from '../../api/profile/profile';
import NotLoggedInRedirection from '../Auth/NotLoggedInRedirection/NotLoggedInRedirection';
import { Link } from 'react-router-dom';
import NFTItem from '../Layouts/NFTItem/NFTItem';
import { mintNFT } from '../../api/nft/nft';
import ErrorMessage from '../Layouts/ErrorMessage/ErrorMessage';
import "./MyItem.css"
import ProfileNftCard from './ProfileNftCard';
import LoadMoreSection from '../Common/LoadMoreSection';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { errorMessageHandler } from '../../utils/utils';
export default function MyItems() {
    const { username } = useParams();
    const currentUser = useSelector(state => state?.Profile?.profile?.user_name)
   
    const [activeTab, setActiveTab] = useState("onSale");
    //loading state
    const [profileLoading, setProfileLoading] = useState(true)
    const [listingLoading, setListingLoading] = useState(true)
    const [ownedLoading, setOwnedLoading] = useState(false)
    const [createdLoading, setCreatedLoading] = useState(false)
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    //data error
    const [profileError, setProfileError] = useState(null);
    const [listingError, setListingError] = useState(null);
    const [ownedError, setOwnedError] = useState(null);
    const [createdError, setCreatedError] = useState(null);
    //data state
    const [profile, setUserProfile] = useState({})
    const [listedNftList, setListedNftList] = useState([])
    const [ownedNftList, setOwnedNftList] = useState([])
    const [createdNftList, setCreatedNftList] = useState([])
    //data pagination object
    const [listingPagination, setListingPagination] = useState({})
    const [ownedPagination, setOwnedPagination] = useState({})
    const [createdPagination, setCreatedPagination] = useState({})
    //default page
    const [listPage, setListPage] = useState(1)
    const [ownPage, setOwnPage] = useState(1)
    const [createdPage, setCreatedPage] = useState(1)
    //cover image
    const [coverImgSrc, setCoverImgSrc] = useState(null)
    const [isUploadingCover, setIsUploadingCover] = useState(false);
  

    const fetchInitialData = async () => {
        try {
            setProfileLoading(true);

            await Promise.all([
                getProfileByUsername(username)
                    .then(res => setUserProfile(res.data.data))
                    .catch((e) => { setProfileError("Getting some issue to load profile") }), // ignore error

                getListedNftList(listPage, username)
                    .then(res => {
                        setListedNftList(res.data.data.tokens);
                        setListingPagination(res.data.data.pagination);
                    })
                    .catch((e) => { setListingError(errorMessageHandler(e) || "Getting some issue to load listed items") }),

                getOwnedNftList(ownPage, username)
                    .then(res => {
                       
                        setOwnedNftList(res.data.data.tokens);
                        setOwnedPagination(res.data.data.pagination);
                    })
                    .catch((e) => { setOwnedError(errorMessageHandler(e) || "Getting some issue to load owned items") }),

                getUserCreatedNftList(createdPage, username)
                    .then(res => {
                       
                        setCreatedNftList(res.data.data.nfts);
                        setCreatedPagination(res.data.data.pagination);
                    })
                    .catch((e) => { setCreatedError(errorMessageHandler(e) || "Getting some issue to load created items") }),
            ]);
        } finally {
            setProfileLoading(false);
            setListingLoading(false);
            setOwnedLoading(false);
            setCreatedLoading(false);
        }
    };

    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchMoreListedNftList = async page => {

        if (!listingPagination?.has_next_page) return;
        try {
            setIsLoadingMore(true);
            const { data } = await getListedNftList(page, username);
            const incoming = data?.data?.tokens || [];
            const pagination = data?.data?.pagination || {};
            setListedNftList(prev => ([...prev, ...incoming]));
            setListingPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            })

        } finally {
            setIsLoadingMore(false);
        }
    };

    const fetchMoreOwnedNftList = async page => {
        if (!ownedPagination?.has_next_page) return;
        try {
            setIsLoadingMore(true);
            const { data } = await getOwnedNftList(page, username);
            const incoming = data?.data?.tokens || [];
            const pagination = data?.data?.pagination || {};
            setOwnedNftList(prev => [...prev, ...incoming]);
            setOwnedPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            })
        } finally {
            setIsLoadingMore(false);
        }
    };

    const fetchMoreCreatedNftList = async page => {
        if (!createdPagination?.has_next_page) return;
        try {
            setIsLoadingMore(true);
            const { data } = await getUserCreatedNftList(page, username);
            const incoming = data?.data?.nfts || [];
            const pagination = data?.data?.pagination || {};
            setCreatedNftList(prev => [...prev, ...incoming]);
            setCreatedPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            })
        } finally {
            setIsLoadingMore(false);
        }
    };




    useEffect(() => {
        if (listPage > 1) fetchMoreListedNftList(listPage);
    }, [listPage]);

    useEffect(() => {
        if (ownPage > 1) fetchMoreOwnedNftList(ownPage);
    }, [ownPage]);

    useEffect(() => {
        if (createdPage > 1) fetchMoreCreatedNftList(createdPage);
    }, [createdPage]);

    const loadMoreListed = () => {
        if (listingPagination?.has_next_page) setListPage(prev => prev + 1);
    };

    const loadMoreOwned = () => {
        if (ownedPagination?.has_next_page) setOwnPage(prev => prev + 1);
    };

    const loadMoreCreated = () => {
        if (createdPagination?.has_next_page) setCreatedPage(prev => prev + 1);
    };




    let uploadProfileCoverPhoto = async (e) => {
        try {
            const input = e.target;
            const file = input.files && input.files[0];
            if (!file) return;

            // Runtime type and size checks
            const allowed = ["image/png", "image/jpeg", "image/gif"];
            if (!allowed.includes(file.type)) {
                // show toast/message as per your app's pattern
                console.warn("Unsupported file type");
                input.value = "";
                return;
            }
            const sizeMB = file.size / (1024 * 1024);
            if (sizeMB > 10) { // tighten limit as needed
                alert("Upload failed. Your file exceeds the 10MB limit.")
                input.value = "";
                return;
            }

            // Fast preview
            const objectUrl = URL.createObjectURL(file);
            setCoverImgSrc(objectUrl);

            setIsUploadingCover(true);
            const formData = new FormData();
            formData.append("img", file);

            const res = await uploadProfileCover(formData);
            // Revoke object URL after upload to avoid leaks
            URL.revokeObjectURL(objectUrl);
        } catch (err) {
            console.error("Profile upload error", err);
            alert("Unable to upload profile cover photo. Try again in a moment.")
            // show toast/Error UI instead of alert
        } finally {
            setIsUploadingCover(false);
            // allow re-selecting the same file
            if (e?.target) e.target.value = "";
        }
    };

    return (

        <main>
            <section id="ItemsProfile" className="py-5 BgGrey">
                <div className="container">
                    <div className='row' id='zIndexMob'>
                        <div className="text-center">
                            <div className="position-relative CoverImageBox">
                                <input id="input-file" onChange={uploadProfileCoverPhoto} type="file" accept="image/png, image/gif, image/jpeg" style={{ display: 'none' }} />
                                {profileLoading ? (
                                    <div className="w-100 rounded d-block CoverSkeleton" aria-busy="true" />
                                ) : (


                                    <img
                                        style={{ height: '300px' }}
                                        src={coverImgSrc ? coverImgSrc : profile?.cover_image ? `${process.env.REACT_APP_IMAGE_URL}/profile/covers/${profile?.cover_image}` : "/images/cover.jpeg"}
                                        alt="Cover Image"
                                        className="w-100 rounded d-block CoverImage"
                                    />
                                )}
                                {!profileLoading && (
                                    <button
                                        onClick={() => { document.getElementById('input-file').click(); }}
                                        className="rounded-pill btn BtnBlue px-3 position-absolute CoverActionBtn"
                                        disabled={isUploadingCover}
                                    >
                                        {isUploadingCover ? <i className="fas fa-asterisk fa-spin" /> : "Add Cover"}
                                    </button>

                                )}
                            </div>
                            {profile?.user_name && profile?.profile_image && <img style={{ backgroundColor: 'white', width: '120px !important', height: '120px !important' }} src={`${process.env.REACT_APP_IMAGE_URL}/profile/personalImage/${profile?.profile_image}`} alt="Profile Image" className="rounded-circle d-block mx-auto w-100 h-100 position-relative ProfileImg mb-3" />}
                            {profile?.user_name && !profile?.profile_image && <img style={{ backgroundColor: 'white', width: '120px !important', height: '120px !important' }} src="/images/user.png" alt="Profile Image" className="rounded-circle d-block mx-auto w-100 h-100 position-relative ProfileImg mb-3" />}

                            <button style={{ width: '35%' }} className="rounded-pill TextEllipsis BgGrey px-3 GreyColor mb-3">
                                {profile?.public_address || profile?.user_name}
                            </button>
                            {profile?.display_name && <p className="m-0"><strong>{profile?.display_name}</strong></p>}
                            {profile?.twitter_username && <p><i className="fa fa-twitter me-2" /> {profile?.twitter_username} {profile?.site_or_portfolio != null ? <React.Fragment> <i className="fa fa-globe me-2" /> {profile?.site_or_portfolio}</React.Fragment> : ''} </p>}



                        </div>
                        {
                            currentUser === username &&

                            <div className="d-flex justify-content-center align-items-center mb-3 mt-4">
                                <Link to="/user/profile/edit" className="rounded-pill btn BtnBorder px-3 shadow-none me-2 RoundButtonHeight">Edit Profile</Link>
                            </div>
                        }


                        <div className="TabBox">
                            <ul className="nav nav-tabs justify-content-center BorderBottom mb-4" id="myTab" role="tablist" style={{ marginTop: "100px" }}>
                                <li className="nav-item" role="presentation">
                                    <button

                                        className="nav-link active" id="Sale-tab" data-bs-toggle="tab" data-bs-target="#Sale" type="button" role="tab" aria-controls="Sale" aria-selected="true">On Sale</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link" id="Owned-tab" data-bs-toggle="tab" data-bs-target="#Owned" type="button" role="tab" aria-controls="Owned" aria-selected="false">Owned</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link" id="Created-tab" data-bs-toggle="tab" data-bs-target="#Created" type="button" role="tab" aria-controls="Created" aria-selected="false">Created</button>
                                </li>


                            </ul>
                            <div className="tab-content MarketDataCard" id="myTabContent">

                                <div className="tab-pane fade show active" id="Sale" role="tabpanel" aria-labelledby="Sale-tab">

                                    {listingError && !listingLoading ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Error Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(220, 38, 38, 0.08))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(239, 68, 68, 0.2)',
                                                position: 'relative'
                                            }}>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', filter: 'drop-shadow(0 4px 16px rgba(239, 68, 68, 0.3))' }}>
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                </svg>
                                            </div>

                                            <h3 style={{
                                                color: '#1a1a1a',
                                                marginBottom: '16px',
                                                fontSize: '32px',
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                Unable to Load Items
                                            </h3>

                                            <p style={{
                                                color: '#6b7280',
                                                fontSize: '17px',
                                                lineHeight: '1.7',
                                                marginBottom: '0',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto'
                                            }}>
                                                {listingError || "Something went wrong while fetching your listed items. Please try again later."}
                                            </p>
                                        </div>
                                    ) : listingLoading && listedNftList.length === 0 ? (
                                        <div className="d-flex justify-content-center flex-wrap">
                                            {new Array(8).fill(1).map((_, index) => (
                                                <ProfileNftCard key={index} />
                                            ))}
                                        </div>
                                    ) : !listingLoading && listedNftList.length === 0 ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(17, 207, 243, 0.1), rgba(105, 239, 183, 0.1))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(17, 207, 243, 0.2)',
                                                position: 'relative',
                                                animation: 'iconFloat 3s ease-in-out infinite'
                                            }}>
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '120%',
                                                    height: '120%',
                                                    background: 'radial-gradient(circle, rgba(17, 207, 243, 0.2) 0%, rgba(105, 239, 183, 0.15) 40%, transparent 70%)',
                                                    borderRadius: '50%',
                                                    animation: 'glowPulse 3s ease-in-out infinite'
                                                }}></div>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#11cff3', filter: 'drop-shadow(0 4px 16px rgba(17, 207, 243, 0.4))', position: 'relative', zIndex: 1 }}>
                                                    <circle cx="9" cy="21" r="1"></circle>
                                                    <circle cx="20" cy="21" r="1"></circle>
                                                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                                                </svg>
                                            </div>

                                            <h2 style={{
                                                color: '#1a1a1a',
                                                marginBottom: '16px',
                                                fontSize: '32px',
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                No Sales Items Found
                                            </h2>

                                            <p style={{
                                                color: '#6b7280',
                                                fontSize: '17px',
                                                lineHeight: '1.7',
                                                marginBottom: '36px',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto 36px'
                                            }}>
                                                You don't have any items for sale.<br />
                                                Start by listing your NFTs or browse the marketplace!
                                            </p>

                                            <Link to="/">
                                                <button className="btn BtnBlack" style={{
                                                    fontSize: '15px',
                                                    fontWeight: '700',
                                                    padding: '14px 36px',
                                                    borderRadius: '12px',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 8px 24px rgba(17, 207, 243, 0.35), 0 4px 12px rgba(105, 239, 183, 0.25)',
                                                    letterSpacing: '0.5px'
                                                }}>
                                                    Browse Marketplace
                                                </button>
                                            </Link>
                                        </div>
                                    ) : (



                                        <div className="d-flex justify-content-center flex-wrap">
                                            {listedNftList.map((data, key) => (
                                                <ProfileNftCard type="listed" key={data.payload} item={data} />
                                            ))}

                                            <LoadMoreSection
                                                hasNextPage={listingPagination.has_next_page}
                                                onLoadMore={loadMoreListed}
                                                isLoading={isLoadingMore || listingLoading}
                                                loadMoreText="Load More"           // Changed from "Load More Orders"
                                                endMessage="No more items to load"  // Changed from "No more cancelled orders to load"
                                                accentColor="243, 23, 23"
                                            />

                                        </div>










                                    )}
                                </div>

                                <div className="tab-pane fade" id="Owned" role="tabpanel" aria-labelledby="Owned-tab">
                                    {ownedError && !ownedLoading ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Error Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(220, 38, 38, 0.08))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(239, 68, 68, 0.2)',
                                                position: 'relative'
                                            }}>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', filter: 'drop-shadow(0 4px 16px rgba(239, 68, 68, 0.3))' }}>
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                </svg>
                                            </div>

                                            <h3 style={{
                                                color: '#1a1a1a',
                                                marginBottom: '16px',
                                                fontSize: '32px',
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                Unable to Load Items
                                            </h3>

                                            <p style={{
                                                color: '#6b7280',
                                                fontSize: '17px',
                                                lineHeight: '1.7',
                                                marginBottom: '0',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto'
                                            }}>
                                                {ownedError || "Something went wrong while fetching your owned items. Please try again later."}
                                            </p>
                                        </div>
                                    ) : ownedLoading && ownedNftList.length === 0 ? (
                                        <div className="d-flex justify-content-center flex-wrap">
                                            {new Array(8).fill(1).map((_, index) => (
                                                <ProfileNftCard key={index} />
                                            ))}
                                        </div>
                                    ) : !ownedLoading && ownedNftList.length === 0 ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(17, 207, 243, 0.1), rgba(105, 239, 183, 0.1))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(17, 207, 243, 0.2)',
                                                position: 'relative',
                                                animation: 'iconFloat 3s ease-in-out infinite'
                                            }}>
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '120%',
                                                    height: '120%',
                                                    background: 'radial-gradient(circle, rgba(17, 207, 243, 0.2) 0%, rgba(105, 239, 183, 0.15) 40%, transparent 70%)',
                                                    borderRadius: '50%',
                                                    animation: 'glowPulse 3s ease-in-out infinite'
                                                }}></div>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#69efb7', filter: 'drop-shadow(0 4px 16px rgba(105, 239, 183, 0.5))', position: 'relative', zIndex: 1 }}>
                                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                                                    <polyline points="21 15 16 10 5 21"></polyline>
                                                </svg>
                                            </div>

                                            <h2 style={{
                                                color: '#1a1a1a',
                                                marginBottom: '16px',
                                                fontSize: '32px',
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                No Owned Items Found
                                            </h2>

                                            <p style={{
                                                color: '#6b7280',
                                                fontSize: '17px',
                                                lineHeight: '1.7',
                                                marginBottom: '36px',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto 36px'
                                            }}>
                                                You don't own any NFTs yet.<br />
                                                Start collecting NFTs on the marketplace!
                                            </p>

                                            <Link to="/">
                                                <button className="btn BtnBlack" style={{
                                                    fontSize: '15px',
                                                    fontWeight: '700',
                                                    padding: '14px 36px',
                                                    borderRadius: '12px',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 8px 24px rgba(17, 207, 243, 0.35), 0 4px 12px rgba(105, 239, 183, 0.25)',
                                                    letterSpacing: '0.5px'
                                                }}>
                                                    Browse Marketplace
                                                </button>
                                            </Link>
                                        </div>
                                    ) : (
                                        <div className="d-flex justify-content-center flex-wrap">
                                            {ownedNftList.map((data, key) => (
                                                <ProfileNftCard type="owned" key={data.payload} item={data} />
                                            ))}

                                            <LoadMoreSection
                                                hasNextPage={ownedPagination.has_next_page}
                                                onLoadMore={loadMoreOwned}
                                                isLoading={isLoadingMore || ownedLoading}
                                                loadMoreText="Load More"           // Changed from "Load More Orders"
                                                endMessage="No more items to load"  // Changed from "No more cancelled orders to load"
                                                accentColor="243, 23, 23"
                                            />

                                        </div>
                                    )}
                                </div>


                                <div className="tab-pane fade" id="Created" role="tabpanel" aria-labelledby="Created-tab">
                                    {createdError && !createdLoading ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Error Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(220, 38, 38, 0.08))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(239, 68, 68, 0.2)',
                                                position: 'relative'
                                            }}>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', filter: 'drop-shadow(0 4px 16px rgba(239, 68, 68, 0.3))' }}>
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                </svg>
                                            </div>

                                            <h3 style={{
                                                color: '#1a1a1a',
                                                marginBottom: '16px',
                                                fontSize: '32px',
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                Unable to Load Items
                                            </h3>

                                            <p style={{
                                                color: '#6b7280',
                                                fontSize: '17px',
                                                lineHeight: '1.7',
                                                marginBottom: '0',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto'
                                            }}>
                                                {createdError || "Something went wrong while fetching your created items. Please try again later."}
                                            </p>
                                        </div>
                                    ) : createdLoading && createdNftList.length === 0 ? (
                                        <div className="d-flex justify-content-center flex-wrap">
                                            {new Array(8).fill(1).map((_, index) => (
                                                <ProfileNftCard key={index} />
                                            ))}
                                        </div>
                                    ) : !createdLoading && createdNftList.length === 0 ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(17, 207, 243, 0.1), rgba(105, 239, 183, 0.1))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(17, 207, 243, 0.2)',
                                                position: 'relative',
                                                animation: 'iconFloat 3s ease-in-out infinite'
                                            }}>
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '120%',
                                                    height: '120%',
                                                    background: 'radial-gradient(circle, rgba(17, 207, 243, 0.2) 0%, rgba(105, 239, 183, 0.15) 40%, transparent 70%)',
                                                    borderRadius: '50%',
                                                    animation: 'glowPulse 3s ease-in-out infinite'
                                                }}></div>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#11cff3', filter: 'drop-shadow(0 4px 16px rgba(17, 207, 243, 0.4))', position: 'relative', zIndex: 1 }}>
                                                    <path d="M12 20h9"></path>
                                                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                                                </svg>
                                            </div>

                                            <h2 style={{
                                                color: '#1a1a1a',
                                                marginBottom: '16px',
                                                fontSize: '32px',
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                No Created Items Found
                                            </h2>

                                            <p style={{
                                                color: '#6b7280',
                                                fontSize: '17px',
                                                lineHeight: '1.7',
                                                marginBottom: '36px',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto 36px'
                                            }}>
                                                You haven't created any NFTs yet.<br />
                                                Start creating your own NFTs or browse the marketplace!
                                            </p>

                                            <Link to="/">
                                                <button className="btn BtnBlack" style={{
                                                    fontSize: '15px',
                                                    fontWeight: '700',
                                                    padding: '14px 36px',
                                                    borderRadius: '12px',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 8px 24px rgba(17, 207, 243, 0.35), 0 4px 12px rgba(105, 239, 183, 0.25)',
                                                    letterSpacing: '0.5px'
                                                }}>
                                                    Browse Marketplace
                                                </button>
                                            </Link>
                                        </div>
                                    ) : (

                                        <div className="d-flex justify-content-center flex-wrap">
                                            {createdNftList.map((data, key) => (
                                                <ProfileNftCard type="created" key={data.payload} item={data} />
                                            ))}

                                            <LoadMoreSection
                                                hasNextPage={createdPagination.has_next_page}
                                                onLoadMore={loadMoreCreated}
                                                isLoading={isLoadingMore || createdLoading}
                                                loadMoreText="Load More"           // Changed from "Load More Orders"
                                                endMessage="No more items to load"  // Changed from "No more cancelled orders to load"
                                                accentColor="243, 23, 23"
                                            />

                                        </div>


                                    )}
                                </div>




























                                {/* <div className="tab-pane fade" id="Created" role="tabpanel" aria-labelledby="Created-tab">
                                {
                                    !itemsCreated.isLoading && itemsCreated.list.length === 0 ? (
                                        <Link to="/">
                                            <div className="text-md-center py-5">
                                                <h2>No Created items found</h2>
                                                <p className="GreyColor">Come back soon! Or try to browse <br /> something for you on our marketplace</p>
                                                <a href="#" className="btn BtnBlack py-2 px-3">Browse Marketplace</a>
                                            </div>
                                        </Link>
                                    ) : (
                                        <div className="d-flex justify-content-center flex-wrap">
                                            {
                                                itemsCreated.list.map(data => <NFTItem key={data.payload} item={data} />)
                                            }
                                            {
                                                itemsCreated.isLoading && new Array(10).fill(1).map((_, index) => <NFTItem key={index} />)
                                            }
                                            <div className="w-100">
                                                <center>
                                                    {itemsCreated.loadMore && <button onClick={() => this.fetchItems(2, itemsCreated.page + 1)} disabled={itemsCreated.isLoading} style={{ width: '30%' }} className="btn BtnBlack">Load More {itemsCreated.isLoading && <i className="fas fa-asterisk fa-spin" />}</button>}
                                                </center>
                                            </div>
                                        </div>
                                    )
                                }
                            </div> */}
                                {/* <div className="tab-pane fade" id="PendingNFT" role="tabpanel" aria-labelledby="Pending-tab">
                                {
                                    !itemsPending.isLoading && itemsPending.list.length === 0 ? (
                                        <Link to="/">
                                            <div className="text-md-center py-5">
                                                <h3>No Pending items found</h3>
                                                <p className="GreyColor Fsize_16">Come back soon! Or try to browse <br /> something for you on our marketplace</p>
                                                <a href="#" className="btn BtnBlack py-2 px-3">Browse Marketplace</a>
                                            </div>
                                        </Link>
                                    ) : (
                                        <div className="d-flex justify-content-center flex-wrap">
                                            {
                                                itemsPending.list.map(data => <NFTItem key={data.payload} item={data} />)
                                            }
                                            {
                                                itemsPending.isLoading && new Array(10).fill(1).map((_, index) => <NFTItem key={index} />)
                                            }
                                            <div className="w-100">
                                                <center>
                                                    {itemsPending.loadMore && <button onClick={() => this.fetchItems(3, itemsPending.page + 1)} disabled={itemsPending.isLoading} style={{ width: '30%' }} className="btn BtnBlack">Load More {itemsPending.isLoading && <i className="fas fa-asterisk fa-spin" />}</button>}
                                                </center>
                                            </div>
                                        </div>
                                    )
                                }
                            </div> */}
                                {/* <div className="tab-pane fade" id="Activity" role="tabpanel" aria-labelledby="Activity-tab">
                                <div className="py-5">
                                    <table className="table mb-3">
                                        <thead>
                                            <tr>
                                                <th scope="col">Token ID</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Price / Bid Amount</th>
                                                <th scope="col">Order ID</th>
                                                <th scope="col">Minted Hash</th>
                                                <th scope="col">Timestamp</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                activities.list.map(data => (
                                                    <tr>
                                                        <th scope="row">{data.token_id}</th>
                                                        <td className="shadows">
                                                            <img className="pictures" src="https://api.vulcanstats.io/data/Vulcan/imgMaps/NFT26820.png" />
                                                            <a className="wolf px-2">{data.title}</a>
                                                        </td>
                                                        <td>{!data.bid_amount ? data.price ? data.price : '-' : '-'} / {data.bid_amount || '-'}</td>
                                                        <td>{data.order_id}</td>
                                                        <td>{data.nft_minted_hash}</td>
                                                        <td>
                                                            <span>01:08 28-Feb-2022</span>
                                                        </td>
                                                    </tr>
                                                ))
                                            }


                                        </tbody>
                                    </table>
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination justify-content-end">
                                            <li className="page-item"><a className="page-link" href="#">Previous</a>
                                            </li>
                                            <li className="page-item"><a className="page-link" href="#">1</a></li>
                                            <li className="page-item"><a className="page-link" href="#">2</a></li>
                                            <li className="page-item"><a className="page-link" href="#">3</a></li>
                                            <li className="page-item"><a className="page-link" href="#">Next</a></li>
                                        </ul>
                                    </nav>
                                </div>
                            </div> */}
                                {/* <div className="tab-pane fade" id="Equity" role="tabpanel" aria-labelledby="Pending-tab">
                                {
                                    !itemsEquity.isLoading && itemsEquity.list.length === 0 ? (
                                        <Link to="/">
                                            <div className="text-md-center py-5">
                                                <h2>No Equity items found</h2>
                                                <p className="GreyColor Fsize_16">Come back soon! Or try to browse <br /> something for you on our marketplace</p>
                                                <a href="#" className="btn BtnBlack py-2 px-3">Browse Marketplace</a>
                                            </div>
                                        </Link>
                                    ) : (
                                        <div className="d-flex justify-content-center flex-wrap">
                                            {
                                                itemsEquity.list.map(data => <NFTItem key={data.payload} item={data} />)
                                            }
                                            {
                                                itemsEquity.isLoading && new Array(10).fill(1).map((_, index) => <NFTItem key={index} />)
                                            }
                                            <div className="w-100">
                                                <center>
                                                    {itemsEquity.loadMore && <button onClick={() => this.fetchItems(3, itemsEquity.page + 1)} disabled={itemsEquity.isLoading} style={{ width: '30%' }} className="btn BtnBlack">Load More {itemsEquity.isLoading && <i className="fas fa-asterisk fa-spin" />}</button>}
                                                </center>
                                            </div>
                                        </div>
                                    )
                                }
                            </div> */}
                                {/* <div className="tab-pane fade" id="Following" role="tabpanel" aria-labelledby="Following-tab">
                                <div className="text-md-center py-5">
                                    <h2>No Following items found</h2>
                                    <p className="GreyColor">Come back soon! Or try to browse <br /> something for you on our marketplace</p>
                                    <a href="#" className="btn BtnBlack py-2 px-3">Browse Marketplace</a>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="Follower" role="tabpanel" aria-labelledby="Follower-tab">
                                <div className="text-md-center py-5">
                                    <h2>No Follower items found</h2>
                                    <p className="GreyColor">Come back soon! Or try to browse <br /> something for you on our marketplace</p>
                                    <a href="#" className="btn BtnBlack py-2 px-3">Browse Marketplace</a>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="Hidden" role="tabpanel" aria-labelledby="Hidden-tab">
                                <div className="text-md-center py-5">
                                    <h2>No Hidden items found</h2>
                                    <p className="GreyColor">Come back soon! Or try to browse <br /> something for you on our marketplace</p>
                                    <a href="#" className="btn BtnBlack py-2 px-3">Browse Marketplace</a>
                                </div>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <NotLoggedInRedirection />
        </main>
    );
}
